export type Theme = 'light' | 'dark' | 'worldline'
export type ThemePreference = Theme | null

export const THEME_KEY = 'theme'
export const WORLDLINE_KEY = 'worldline-unlocked'
export const WORLDLINE_COUNT_KEY = 'worldline-activation-count'
export const WORLDLINE_EVENT = 'worldline-unlocked'

export function storedTheme(value: string | null, unlocked: boolean): ThemePreference {
  if (value === 'light' || value === 'dark') return value
  if (value === 'worldline' && unlocked) return value
  return null
}

export function nextThemePreference(current: ThemePreference, unlocked: boolean): ThemePreference {
  if (current === null) return 'light'
  if (current === 'light') return 'dark'
  if (current === 'dark') return unlocked ? 'worldline' : null
  return null
}

export function registerMeterActivation(
  count: number,
  unlocked: boolean,
): { count: number; unlock: boolean } {
  if (unlocked) return { count: 0, unlock: false }
  const next = Math.max(0, Math.trunc(count)) + 1
  return next >= 3 ? { count: 0, unlock: true } : { count: next, unlock: false }
}
